import { create } from "zustand";
import { DataState, RFMType } from "../constants/enums";

interface BrandMemberSegment {
  Id?: number;
  BrandId?: string;
  SegmentName?: string;
  Description?: string;
  CreatedDate?: string;
  BrandMemberSegmentDetails?: BrandMemberSegmentDetail[];
  DataState?: DataState;
}

interface BrandMemberSegmentDetail {
  Id?: number;
  Recency: RFMType;
  Frequency: RFMType;
  Monetary: RFMType;
  BrandMemberSegmentId?: number;
  DataState?: DataState;
  UpdatedDate: string;
}

interface BrandMemberSegmentStore {
  brandMemberSegmentDraft: BrandMemberSegment[];
  setBrandMemberSegmentDraft: (
    updater:
      | BrandMemberSegment[]
      | ((prev: BrandMemberSegment[]) => BrandMemberSegment[])
  ) => void;
}

export const useBrandMemberSegmentStore = create<BrandMemberSegmentStore>(
  (set) => ({
    brandMemberSegmentDraft: [],
    setBrandMemberSegmentDraft: (updater) =>
      set((state) => ({
        brandMemberSegmentDraft:
          typeof updater === "function"
            ? updater(state.brandMemberSegmentDraft)
            : updater,
      })),
  })
);
